import { Header } from './header'
import React from 'react'
import * as PropTypes from 'prop-types'
import { NavFooter } from './navFooter'
import { Participants } from './participants'
import { createPortal } from 'react-dom'
import { RootStore } from '../../../datastores/rootStore'
import { ValidateAddParticipantController } from '../../../datastores/validateAddParticipantController'
import { observer } from 'mobx-react-lite'
import { StepController } from '../../../datastores/stepController'
import GA4Tracking from '../../../utils/ga4-tracking'

export const EditParticipantsDialog = observer(function EditParticipantsDialog(
  props
) {
  const validateAddParticipantController = ValidateAddParticipantController.getInstance()

  return props.open
    ? createPortal(
        <div className={'mtt-modal mtt-modal--visible mtt-modal--participants'}>
          <div className={'mtt-modal__overlay'}>
            <div
              className={'mtt-modal__container'}
              onClick={e => {
                e.stopPropagation()
              }}
            >
              <button
                className={'mtt-modal__close'}
                onClick={() => {
                  props.onClose()
                }}
                disabled={validateAddParticipantController.loading}
              />
              <Header eventGroup={props.eventGroup} />
              <Participants
                p={props.p}
                eventGroups={[props.eventGroup]}
                displayExisting={true}
              />
              <NavFooter
                onBack={() => {
                  props.onClose()
                }}
                loading={validateAddParticipantController.loading}
                backDisabled={validateAddParticipantController.loading}
                saveDisabled={
                  validateAddParticipantController.loading ||
                  !validateAddParticipantController.isAllValid
                }
                onSubmit={async () => {
                  let oldParticipantsCount = Object.keys(props.eventGroup.participants).length
                  await validateAddParticipantController.validate(
                    [props.eventGroup],
                    props.p.ps,
                    RootStore.getInstance().cart.customer,
                    RootStore.getInstance().cart.coupon,
                    false,
                    {
                      other_cart_items: RootStore.getInstance().cart.eventGroups.filter(eg => eg.id !== props.eventGroup.id),
                    }
                  )

                  if (validateAddParticipantController.isAllValid) {
                    StepController.getInstance().validationResults.delete(`eventGroups.${props.eventGroup.id}`)
                    props.p.submit()
                    let cart = RootStore.getInstance().cart
                    cart.updateContent(
                      validateAddParticipantController.validation_data
                    )

                    let newParticipantsCount = Object.keys(props.eventGroup.participants).length
                    newParticipantsCount = oldParticipantsCount === 0 ? newParticipantsCount - 1 : newParticipantsCount
                    let items = GA4Tracking.getItemsAndAddonsFromCartEventGroups([props.eventGroup])
                    GA4Tracking.handleUpdateOfProductsInCart(items, oldParticipantsCount, newParticipantsCount)

                    props.onClose()
                  }
                }}
              />
            </div>
          </div>
        </div>,
        document.body
      )
    : null
})
EditParticipantsDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  p: PropTypes.any,
  eventGroup: PropTypes.object.isRequired
}
